export default __webpack_public_path__ + "static/media/Dash Me 2.5c997399.svg";